import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import CardSimple from "@/components/CardSimple";
import { MODEL_KEY } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";

const UserOrganizationName = ({ organization, loading }) => {
  const { t } = useTranslation();

  return (
    <CardSimple
      title={organization?.name}
      icon={<ModelIcon model={MODEL_KEY.ORGANIZATION} />}
      secondaryTitle={t("global:organization")}
      loading={loading}
      fixedWidth
    />
  );
};

UserOrganizationName.propTypes = {
  organization: PropTypes.object,
  loading: PropTypes.bool,
};

export default UserOrganizationName;
